import React, { useCallback, useState } from 'react'
import { IMarketCustomerWithDetails, IMarketOrderNote } from '../../../../../../modules/API/Market/models/marketRequests'
import { Market } from '../../../../../../modules/API/Market/market'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'

type Props = {
  defaultNote: IMarketOrderNote
}

const useOrderNote = ({
  defaultNote
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [note, setNote] = useState<IMarketOrderNote>(defaultNote)
  const [marketItem, setMarketItem] = useState<IMarketCustomerWithDetails | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const handleOpen = (item: IMarketCustomerWithDetails) => {
    setIsOpen(true)
    setNote(item.OrderNote)
    setMarketItem(item)
  }

  const handleClose = useCallback(() => {
    setIsOpen(false)
    setNote(defaultNote)
    setMarketItem(null)
  }, [])
  const handleSave = useCallback(async (note: IMarketOrderNote) => {
    if (!marketItem) return
    setNote(note)
    try {
      setIsLoading(true)
      await Market.patchOrderNote({CustomerSeller: marketItem.CustomerSeller, OrderNote: note.Note})
      handleNotifications("הערה עודכנה בהצלחה", {type: "success"})
      handleClose()
    } catch (error) {
      console.error(error)
      handleNotifications("משהו השתבש", {type: "error"})
    } finally {
      setIsLoading(false)
    }
  }, [marketItem, note, handleClose])


  return (
    {
      isOpen,
      note,
      handleOpen,
      handleClose,
      handleSave,
      isLoading
    }
  )
}

export default useOrderNote